exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".properties__optionslist[data-v-779900f0]{margin-bottom:5px;list-style:none}.properties__optionsul[data-v-779900f0]{padding:0}", ""]);

// exports
